import './BooksCreate.scss'
import { Link } from 'react-router-dom'
import BooksForm from '../components/BookForm/BookForm'

const BooksCreate = () => {
  return (
    <div className='content-card'>
      <div className='row page-title create-book-header'>
        <h1>Criar livro</h1>
        <Link
          to='/books'
          className='button-full go-back-button'
        >
          Voltar
        </Link>
      </div>
      <div className='row content-header'>
        <BooksForm />
        <div className='create-book-buttons'>
          <button
            type='submit'
            form='create-book-form'
            className='button-full btn-save create-book-button'
          >
            Criar
          </button>
        </div>
      </div>
    </div>
  )
}

export default BooksCreate
